import Customer from './Features/Customer.js';
import Auth from './Features/Auth.js';
import Admin from './Features/Admin.js';
import Market from './Features/Market.js';
import Report from './Features/Report.js';
import MenuItem from './model/MenuItem.js';
import Chat from './Features/Chat.js';
import Setting from './Features/Setting.js';
import Shop from './Features/Shop.js';
import ShopSetting from './Features/ShopSetting.js';
import Chatbot from './Features/Chatbot.js';
import Moztech from './Features/Moztech.js';

const DefaultMenu = new MenuItem();
DefaultMenu.RegisterChild(Admin);
DefaultMenu.RegisterChild(Customer);
DefaultMenu.RegisterChild(Auth);
DefaultMenu.RegisterChild(Market);
DefaultMenu.RegisterChild(Setting);
DefaultMenu.RegisterChild(Report);
DefaultMenu.RegisterChild(Chat);
DefaultMenu.RegisterChild(Chatbot);
DefaultMenu.RegisterChild(Shop);
DefaultMenu.RegisterChild(ShopSetting);
DefaultMenu.RegisterChild(Moztech);

export {
  DefaultMenu,
  MenuItem
};
